import { render } from "./App.vue?vue&type=template&id=5562d782"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5562d782&lang=css"

import exportComponent from "/home/runner/work/mehimself.github.io/mehimself.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__